import AccordeonMenu from './AccordeonMenu'

export default AccordeonMenu
